// TODO: JE ZDE DOČASNĚ VIZ: https://github.com/nuxt/nuxt/issues/28869
import type {
  ComponentCustomOptions as _ComponentCustomOptions,
  ComponentCustomProperties as _ComponentCustomProperties,
} from 'vue'
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties extends _ComponentCustomProperties {}
  interface ComponentCustomOptions extends _ComponentCustomOptions {}
}

import type { ModuleOptions } from '../../modules/runtime'

export default defineNuxtPlugin({
  name: 'locale',
  // shared-components-plugin: bez něj může $sharedComponentsOptions být ještě
  // undefined (paralelní pluginy) a localTranslations guard níže by neplatil.
  dependsOn: ['i18n:plugin', 'shared-components-plugin'],
  setup: async (nuxtApp) => {
    // Lokální překlady: @nuxtjs/i18n načítá z app/locales/<code>.json, takže
    // runtime BE-fetch (/public/translations/generate) přeskočíme úplně.
    const sharedComponentsOptions = nuxtApp.$sharedComponentsOptions as ModuleOptions | undefined
    if (sharedComponentsOptions?.options?.i18n?.localTranslations) {
      return
    }

    const { loadMessages } = useLocale()
    const { public: config } = useRuntimeConfig()
    const locale = Object.entries(config.locales ?? {}).find(
      ([localeShort]) => nuxtApp.$i18n.locale.value === localeShort
    )

    if (locale) {
      nuxtApp.hook('i18n:beforeLocaleSwitch', async ({ initialSetup }) => {
        if (initialSetup) {
          await nuxtApp.runWithContext(async () => {
            const messages = await loadMessages(locale[1], locale[0])
            nuxtApp.$i18n.messages.value[nuxtApp.$i18n.locale.value] = messages
          })
        }
      })
      nuxtApp.hook('app:created', (e) => {
        if (e?.__VUE_I18N__?.global?.missingWarn) {
          e.__VUE_I18N__.global.missingWarn = false
        }
      })
    }
  },
})
